var mention = function mention(node, schema) {
  if (['all', 'here'].indexOf(node.attrs.id) !== -1) {
    return "@".concat(node.attrs.id);
  }
  return "".concat(node.attrs.text || '@unknown');
};
export default mention;